"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNewJobResponse = void 0;

var _modelBuilders = require("../../../../utils/model-builders");

var _genericAsResultHeader = require("../../../../utils/generic-as-result-header");

var createNewJobResponse = function createNewJobResponse(raw) {
  return (0, _modelBuilders.parseModel)(raw, {
    result: {
      path: 'AddNewJobResult[0]',
      model: _genericAsResultHeader.genericAsResultHeader
    },
    response: function response(raw) {
      return {
        id: Number(raw.JobQueueId)
      };
    }
  });
};

exports.createNewJobResponse = createNewJobResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/image-analysis/jobs/response-parsers/new-job-response.js
// module id = 227
// module chunks = 0